<template>
    <div>
        <h3 class="display-4">{{question ? question.text : '?' }}</h3>
        <v-divider></v-divider>
        <v-radio-group
                class="justify-center"
                v-model="answer" :mandatory="true">
            <v-radio label="Knows" :value="'pass'"></v-radio>
            <v-radio label="Doesn't know" :value="'fail'"></v-radio>
        </v-radio-group>
    </div>
</template>

<script>
    export default {
        name: "QuestionPassFailDisplay",
        props: {
            question: undefined,
            value: undefined
        },
        watch: {
            answer() {
                this.$emit('input', this.answer);
            },
            value() {
                this.answer = this.value;
            }
        },
        data: function() {
            return {
                answer: undefined
            }
        },
    }
</script>

<style scoped>

</style>
